// import React from "react";
// import "./sidebar.css";
// import logo from "../../Assets/Images/logo__sec.png";
// import { Link } from "react-router-dom";
// // import { TreeView, TreeItem } from "@material-ui/lab";
// import ImportExportIcon from "@mui/icons-material/ImportExport";
// import TreeView from "@mui/lab/TreeView";
// import TreeItem, { TreeItemProps, treeItemClasses } from "@mui/lab/TreeItem"; // import PostAddIcon from "@material-ui/icons/PostAdd";
// import AddIcon from "@mui/icons-material/Add";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ListAltIcon from "@mui/icons-material/ListAlt";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PeopleIcon from "@mui/icons-material/People";
// import RateReviewIcon from "@mui/icons-material/RateReview";

// const Sidebar = () => {
//   return (
//     <div className="sidebar">
//       <Link to="/">
//         <img
//           style={{ width: "80px", objectFit: "cover" }}
//           src={logo}
//           alt="Ecommerce"
//         />
//       </Link>
//       <Link to="/admin/dashboard">
//         <p>
//           <DashboardIcon /> Dashboard
//         </p>
//       </Link>

//       <Link>
//         <TreeView
//           defaultCollapseIcon={<ExpandMoreIcon />}
//           defaultExpandIcon={<ImportExportIcon />}
//         >
//           <TreeItem nodeId="1" label="Products">
//             <Link to="/admin/products">
//               <TreeItem nodeId="2" label="All" />
//             </Link>

//             <Link to="/admin/createproject">
//               <TreeItem nodeId="3" label="Create" />
//             </Link>
//           </TreeItem>
//         </TreeView>
//       </Link>

//       <Link>
//         <TreeView
//           defaultCollapseIcon={<ExpandMoreIcon />}
//           defaultExpandIcon={<ImportExportIcon />}
//         >
//           <TreeItem nodeId="1" label="Catalog">
//             <Link to="/admin/categories">
//               <TreeItem nodeId="2" label="All Categories" />
//             </Link>

//             <Link to="/admin/categories/create">
//               <TreeItem nodeId="3" label="Create Category" />
//             </Link>

//             <Link to="/admin/categories/create-sub">
//               <TreeItem nodeId="3" label="Create Sub Category" />
//             </Link>

//             <Link to="/admin/sizes">
//               <TreeItem nodeId="3" label="Sizes" />
//             </Link>

//             <Link to="/admin/pincodes">
//               <TreeItem nodeId="3" label="Pin Codes" />
//             </Link>
//           </TreeItem>
//         </TreeView>
//       </Link>

//       <Link to="/admin/orders">
//         <p>
//           <ListAltIcon />
//           Orders
//         </p>
//       </Link>
//       <Link to="/admin/users">
//         <p>
//           <PeopleIcon /> Users
//         </p>
//       </Link>
//       <Link to="/admin/reviews">
//         <p>
//           <RateReviewIcon />
//           Reviews
//         </p>
//       </Link>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./sidebar.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faTicket,
  faMapPin,
  faLongArrowAltRight,
  faHeader,
  faCartPlus,
  faListAlt,
  faShoppingCart,
  faUsers,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedoutUser } from "../../Redux/slices/user";
import Swal from "sweetalert2";

const Sidebar = () => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(getLoggedoutUser());
    Swal.fire({
      icon: "success",
      title: "Logged Out Successfully",
    });
  };

  return (
    <div className="sidebar">
      <ul>
        <Link to="/admin" style={{ color: "white" }}>
          <li className="option active">
            <span>
              {" "}
              <FontAwesomeIcon icon={faHome} />{" "}
            </span>
            Dashboard
          </li>
        </Link>

        <Link to="/admin/orders" style={{ color: "white" }}>
          <li className="option">
            <span>
              <FontAwesomeIcon icon={faShoppingCart} />
            </span>
            All Orders
          </li>
        </Link>

        <Link to="/admin/products" style={{ color: "white" }}>
          <li>
            <span>
              <FontAwesomeIcon icon={faListAlt} />
            </span>
            All Products
          </li>
        </Link>

        <Link to="/admin/createproject" style={{ color: "white" }}>
          <li>
            <span>
              <FontAwesomeIcon icon={faCartPlus} />
            </span>
            Create Products
          </li>
        </Link>

        <Link to="/admin/categories" style={{ color: "white" }}>
          <li>
            <span>
              <FontAwesomeIcon icon={faListAlt} />
            </span>
            All Categories
          </li>
        </Link>

        <Link to="/admin/categories/create" style={{ color: "white" }}>
          <li>
            <span>
              <FontAwesomeIcon icon={faCartPlus} />
            </span>
            Create Category
          </li>
        </Link>

        <Link to="/admin/coupons" style={{ color: "white" }}>
          <li>
            <span>
              <FontAwesomeIcon icon={faTicket} />
            </span>
            Coupons Manager
          </li>
        </Link>

        {/* no need for sub categories  */}
        {/* <Link to="/admin/categories/create-sub" style={{ color: "white" }}>
              <li>
                <FontAwesomeIcon icon={faCreditCardAlt} />
                Create Subcategory
              </li>
            </Link> */}

        {/* <Link to="/admin/sizes" style={{ color: "white" }}>
              <li>
                <FontAwesomeIcon icon={faCreditCardAlt} />
                Sizes
              </li>
            </Link> */}

        <Link to="/admin/pincodes" style={{ color: "white" }}>
          <li>
            <span>
              <FontAwesomeIcon icon={faMapPin} />
            </span>
            Pincodes Manager
          </li>
        </Link>

        <Link to="/admin/users" style={{ color: "white" }}>
          <li className="option">
            <span>
              <FontAwesomeIcon icon={faUsers} />
            </span>
            All Users
          </li>
        </Link>

        <Link to="/admin/reviews" style={{ color: "white" }}>
          <li className="option">
            <span>
              <FontAwesomeIcon icon={faStar} />
            </span>
            Reviews
          </li>
        </Link>

        <Link to="/admin/header" style={{ color: "white" }}>
          <li className="option">
            <span>
              <FontAwesomeIcon icon={faHeader} />
            </span>
            Header Promotion
          </li>
        </Link>

        <div onClick={handleLogout} style={{ color: "white" }}>
          <li className="option">
            <span>
              <FontAwesomeIcon icon={faLongArrowAltRight} />
            </span>
            Logout
          </li>
        </div>
      </ul>
    </div>
  );
};

export default Sidebar;
